<template>
  <div class="">
    <VisitantForm />
    <BarTop
      class="px-1"
      :title="is_pt_br ?  `Blocos cadastrados` : `Registered blocks ` + `(${totalStones})` "
      :input="true"
      :placeholder="is_pt_br ? `Buscar (nome, numero, #tipo ou #ID)` : `Search (name, number, #type or #ID)`"
      @get-search="handleSearch"
    >
      <button class="ml-3 btn btn-outline-dark">+{{is_pt_br ? 'Bloco' : 'Block'}}</button>
    </BarTop>
    <div class="row px-1 mt-3">
      <div
        v-for="item in stones_filter"
        :key="item.id"
        class="col-md-6 col-lg-4 col-12 mb-3"
      >
        <CardStone :stone="item" @clicked="inspectStone(item)" />
      </div>

      <div class="p-5 col-12 d-flex justify-content-center">
        <button
          @click.prevent="getPage()"
          class="btn-add-page bg-white btn d-flex align-items-center"
          :disabled="nextPageDisable"
        >
         {{is_pt_br ? 'Ver mais' : 'Show more'}}
          <!-- <i class="ml-2 icon icon-add"></i> -->
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CardStone from "../../components/stone/CardStine.vue";
import BarTop from "../../components/utils/BarTop.vue";
import VisitantForm from '../../components/popups/VisitantForm.vue'

import { mapActions, mapGetters } from "vuex";

export default {
  name: "StoneList",
  components: { CardStone, BarTop, VisitantForm },
  data() {
    return {
      search_token: null,
    };
  },
  computed: {
    ...mapGetters("stone", ["stoneList", "totalStones", "nextPageDisable"]),
    is_pt_br(){
      return this.$store.getters.is_pt_br
    },
    stones_filter() {
      return this.stoneList.filter((el) => {
        if (isNaN(this.search_token)) {
          return this.search_token.length
            ? el.name_material
                .toLowerCase()
                .includes(this.search_token.toLowerCase())
            : true;
        } else if (this.search_token > 0) {
          return parseInt(this.search_token) === parseInt(el.id);
        }
        return true;
      });
    },
  },
  created() {
    if (this.stoneList.length == 0) this.setStones();
  },
  methods: {
    ...mapActions("stone", ["setStones", "selectStone", "searchStones"]),
    inspectStone(stone) {
      this.selectStone(stone);
      this.$router.push({ name: "StoneDetail", params: { id: stone.id } });
    },
    handleSearch(token) {
      this.searchStones(token);
      // this.search_token = token;
    },

    getPage() {
      this.setStones();
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  height: 20px;
  width: 20px;
}

.btn-add-page {
  font-size: 18px !important;
  border: 1px solid #cccccc;
  .icon {
    // height: 24px;
    // width: 24px;
  }
}
</style>
